import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

export default function Navbar({ onCartOpen, selectedPlatform, onPlatformSelect }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { getCartCount } = useCart();

  const handlePlatformClick = (platform) => {
    setIsMenuOpen(false);
    if (onPlatformSelect) {
      // Estamos na Home — muda a plataforma
      onPlatformSelect(platform);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Estamos noutra página — vai para a Home
      navigate('/');
    }
  };

  const platforms = ['Instagram', 'TikTok', 'YouTube', 'Facebook'];
  const platformIds = ['instagram', 'tiktok', 'youtube', 'facebook'];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 py-2 sm:py-3">
        <div className="flex items-center justify-between">

          {/* Esquerda: botão menu mobile + nav desktop */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 hover:bg-gray-100 rounded-lg transition"
            >
              {isMenuOpen ? <X className="w-6 h-6 text-gray-700" /> : <Menu className="w-6 h-6 text-gray-700" />}
            </button>

            <nav className="hidden md:flex items-center gap-6">
              {platformIds.map((id, i) => (
                <button
                  key={id}
                  onClick={() => handlePlatformClick(id)}
                  className={`text-sm font-semibold transition-colors ${
                    selectedPlatform === id ? 'text-pink-600' : 'text-gray-700 hover:text-pink-600'
                  }`}
                >
                  {platforms[i]}
                </button>
              ))}
              <Link to="/contact" className="text-sm font-semibold text-gray-700 hover:text-pink-600 transition-colors">
                Contato
              </Link>
            </nav>
          </div>

          {/* Centro: Logo */}
          <div className="absolute left-1/2 transform -translate-x-1/2">
            <img
              src="/logo.png"
              alt="GrowPlus Logo"
              className="h-10 sm:h-12 w-auto object-contain drop-shadow-md cursor-pointer"
              style={{ filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.15))' }}
              onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            />
          </div>

          {/* Direita: Carrinho */}
          <button
            onClick={() => onCartOpen ? onCartOpen() : navigate('/', { state: { openCart: true } })}
            className="relative p-2 hover:bg-gray-100 rounded-full transition"
          >
            <ShoppingCart className="w-5 sm:w-6 h-5 sm:h-6 text-gray-700" />
            {getCartCount() > 0 && (
              <span className="absolute -top-1 -right-1 bg-pink-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                {getCartCount()}
              </span>
            )}
          </button>
        </div>

        {/* Menu Mobile Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden mt-3 pb-3 border-t border-gray-200 pt-3">
            <nav className="flex flex-col gap-3">
              {platformIds.map((id, i) => (
                <button
                  key={id}
                  onClick={() => handlePlatformClick(id)}
                  className={`text-left text-sm font-semibold transition-colors py-2 px-3 rounded-lg ${
                    selectedPlatform === id ? 'text-pink-600 bg-pink-50' : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {platforms[i]}
                </button>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className="text-left text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors py-2 px-3 rounded-lg"
              >
                Contato
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
